import { useEffect, useState } from "react";
import { decodeHTML } from "~/Utils/CommonUtils";

const AsyncDataDisplay = ({ field, value }: { field: any; value: any }) => {
  const [labels, setLabels] = useState<string[]>([]);

  useEffect(() => {
    const values = Array.isArray(value)
      ? value
      : typeof value === "string" && value.includes(",")
        ? value.split(",").map((v: string) => v.trim())
        : value !== null && value !== undefined
          ? [value]
          : [];

    // Special case: For parent_id fields, show the ID value directly, not the label
    // if (field.name === "parent_id" || field.fieldValue === "parent_id") {
    //   const plainValues = values
    //     .map((v) => (v ? String(v) : ""))
    //     .filter((l) => l && l.trim() !== "");
    //   setLabels(plainValues);
    //   return;
    // }

    // Helper: extract label safely
    const getLabel = (val: any, options: any[]) => {
      if (!val) return null;

      // if object with a label → use it
      if (typeof val === "object" && val.label) return val.label;

      const compareVal = typeof val === "object" ? (val.value ?? val.id ?? val.label ?? "") : val;

      if (!compareVal) return null;

      const found = options.find((opt: any) => {
        try {
          return String(opt.value) === String(compareVal) || String(opt.label) === String(compareVal);
        } catch {
          return false;
        }
      });

      return found?.label || null;
    };

    // Case 1 → loadOptions
    if (field.loadOptions) {
      field
        .loadOptions()
        .then((opts: any) => {
          const matched = values.map((v) => getLabel(v, opts)).filter((l) => l && l.trim() !== "");

          setLabels(matched); // only real labels
        })
        .catch(() => setLabels([]));
      return;
    }

    // Case 2 → static options
    if (field.options) {
      const matched = values.map((v) => getLabel(v, field.options)).filter((l) => l && l.trim() !== "");

      setLabels(matched);
      return;
    }

    // Case 3 → no options (use plain value)
    const plainValues = values.map((v) => (v ? String(v) : "")).filter((l) => l && l.trim() !== "");

    setLabels(plainValues);
  }, [field.loadOptions, field.options, field.name, field.fieldValue, value]);

  return <>{labels.length > 0 && labels.map((label, i) => <div key={i}>{decodeHTML(label)}</div>)}</>;
};

export default AsyncDataDisplay;
